/**
 * @file Маршруты приложения и граница авторизованной части.
 *
 * После входа доступны страницы dashboard. Менеджеры передач находятся выше
 * этих страниц, чтобы смена папки не прерывала загрузку или скачивание.
 * При выходе UploadProvider и DownloadProvider отменяют активные передачи.
 * Общие снимки папок/квоты очищает UploadProvider; схема владения — в README,
 * раздел «Время жизни состояния».
 */
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { useCustomer } from './context/useCustomer'
import { DownloadProvider } from './features/downloads/DownloadProvider'
import SignInPage from './features/session/SignInPage'
import type { OneTimeSignInAttempt } from './features/session/oneTimeSignIn'
import StorageListPage from './features/storages/StorageListPage'
import { UploadProvider } from './features/uploads/UploadProvider'
import Box from './pages/Box'
import DashboardLayout from './pages/DashboardLayout'
import SignInOTAT from './pages/OTAT'

function App({
    oneTimeSignIn,
}: {
    oneTimeSignIn: OneTimeSignInAttempt | null
}) {
    const { customer, isLoaded } = useCustomer()

    // Ждём только начальное восстановление сессии. Для OTAT isLoaded сразу true,
    // иначе экран, который должен выполнить вход, не смог бы появиться.
    if (!isLoaded) return <div>Loading...</div>

    return (
        <BrowserRouter>
            <Routes>
                {/* OTAT доступен независимо от customer: после setCustomer экран
                    должен сам завершить переход, а не попасть в общий редирект. */}
                <Route
                    path='otat'
                    element={<SignInOTAT attempt={oneTimeSignIn} />}
                />
                {customer ? (
                    <>
                        <Route
                            path='/dashboard'
                            element={
                                <UploadProvider>
                                    <DownloadProvider>
                                        <DashboardLayout />
                                    </DownloadProvider>
                                </UploadProvider>
                            }
                        >
                            <Route index element={<Navigate to='boxes' />} />
                            <Route path='boxes' element={<StorageListPage />} />
                            <Route path='box/:boxId' element={<Box />} />
                        </Route>
                        <Route
                            path='*'
                            element={<Navigate to='/dashboard' />}
                        />
                    </>
                ) : (
                    <>
                        <Route path='*' element={<SignInPage />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    )
}

export default App
